import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Image {
  url: string;
  caption: string;
}
interface ImageCarouselProps {
  images: Image[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  const goToNext = () => {
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex);
  };
  return <div className="relative w-full mb-16" data-id="element-77" data-mp="3ll96z6xs00jw">
      {/* Main image container */}
      <div className="h-[500px] w-full relative rounded-lg overflow-hidden shadow-xl" data-id="element-78" data-mp="d5zacecnnnji">
        <img src={images[currentIndex].url} alt={`Slide ${currentIndex + 1}`} className="w-full h-full object-cover" data-id="element-79" data-mp="hz268t4wn92v" />
        {/* Caption overlay */}
        <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-4" data-id="element-80" data-mp="qj4xfxxu3lr">
          <p className="text-white text-center" data-id="element-81" data-mp="egmnnwxlzf6g">
            {images[currentIndex].caption}
          </p>
        </div>
        {/* Navigation arrows */}
        <div onClick={goToPrevious} className="absolute top-1/2 left-4 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full cursor-pointer transition-colors" data-id="element-82" data-mp="9ov3c451q5or">
          <ChevronLeftIcon size={24} data-id="element-83" data-mp="ji3ipbtew7f4" />
        </div>
        <div onClick={goToNext} className="absolute top-1/2 right-4 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-2 rounded-full cursor-pointer transition-colors" data-id="element-84" data-mp="xg0kcmmq340n">
          <ChevronRightIcon size={24} data-id="element-85" data-mp="2z86jxeadkayh" />
        </div>
      </div>
      {/* Thumbnail navigation */}
      <div className="flex mt-4 overflow-x-auto py-2 space-x-2" data-id="element-86" data-mp="2u93psovxnp5a">
        {images.map((image, index) => <div key={index} onClick={() => goToSlide(index)} className={`w-24 h-16 flex-shrink-0 cursor-pointer rounded-md overflow-hidden transition-opacity ${currentIndex === index ? 'ring-2 ring-blue-400 opacity-100' : 'opacity-60'}`} data-id="element-87" data-mp="y67c13crsi7i" data-mpi={index}>
            <img src={image.url} alt={`Thumbnail ${index + 1}`} className="w-full h-full object-cover" data-id="element-88" data-mp="1c5q8gyw7y53z" />
          </div>)}
      </div>
    </div>;
}